<!-- eslint-disable vue/no-unused-refs -->
<template>
  <QS-scroller-box>
    <form-text-box ref="baseInfo" :column="3" :dataList="renderData.list.customerFormList"
      :model="renderData.model.customerFormModel" :rules="renderData.rules.customerRules" />
    <el-divider></el-divider>
    <form-text-box ref="customerInfo" :column="3" :dataList="renderData.list.customerTextList"
      :model="renderData.model.customerTextModel" />
    <template slot="bottomAction">
      <el-button @click="cancel" size="mini">取消</el-button>
      <el-button @click="confirm" size="mini" type="primary">确认，下一步</el-button>
    </template>
  </QS-scroller-box>
</template>
<script>
export default {
  props: {
    renderData: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    confirm() {
      const { customerFormModel } = this.renderData.model
      if (!customerFormModel.customerId) {
        this.$message.error('请先选择客户')
        return
      }
      this.handelToppreview()
      this.$emit('confirm')
    },
    handelToppreview() {
      const { topPreviewModel, customerFormModel, customerTextModel } = this.renderData.model
      topPreviewModel.customerName = customerTextModel.customerName
      topPreviewModel.deptName = customerFormModel.deptName
    },
  },
}
</script>
